import { render } from "./DetalharPlanoConta.vue?vue&type=template&id=000051c4&scoped=true"
import script from "./DetalharPlanoConta.vue?vue&type=script&lang=js"
export * from "./DetalharPlanoConta.vue?vue&type=script&lang=js"

import "./DetalharPlanoConta.vue?vue&type=style&index=0&id=000051c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000051c4"]])

export default __exports__